function headerScrollHandler() {
  if (window.pageYOffset > 20) {
    document.body.classList.add('cc-header-scrolling');
  } else {
    document.body.classList.remove('cc-header-scrolling');
  }
}

window.addEventListener('scroll', headerScrollHandler);
document.addEventListener('DOMContentLoaded', headerScrollHandler);

const header = document.querySelector('.cc-header--root');
const mainContent = document.querySelector('main#main_content');

if (window.stickyHeader === 'true' && document.body.classList.contains('template--index') && header && mainContent) {
  function layoutPaddingHandler() {
    const headerHeight = header.offsetHeight;

    mainContent.style.paddingTop = `${headerHeight}px`;
    mainContent.style.marginTop = `-${headerHeight}px`;
  }

  document.addEventListener('DOMContentLoaded', layoutPaddingHandler);
  window.addEventListener('load', layoutPaddingHandler);
  window.addEventListener('resize', layoutPaddingHandler);
  window.addEventListener('orientationchange', layoutPaddingHandler);
}
